import { render, staticRenderFns } from "./dialog-businesscard-update.vue?vue&type=template&id=b351e20c&"
import script from "./dialog-businesscard-update.vue?vue&type=script&lang=js&"
export * from "./dialog-businesscard-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports